import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ProductStats } from '../api/models';
import * as d3 from 'd3'; // Import D3.js
import { PieArcDatum } from 'd3-shape';


interface DonutData {
    label: string;
    value: number;
}
@customElement('promo-donut')
export class PromoDonut extends LitElement {

    @property({ type: Object }) stats: ProductStats | null = null;

    @property({ type: Number }) width: number = 500;

    @property({ type: Number }) height: number = 500;

    static styles = css`
    .product-count {
        font-size: 5em;
        color: var(--sl-color-primary-500);
        font-family: var(--sl-font-sans);
        font-weight: var(--sl-font-weight-bold);
    }

    .title-background {
        fill: var(--sl-color-primary-100);
    }
    `

    render() {
        return html`
        <div id="svgContainer">
            <svg id="stats" style="box-sizing: border-box;" width="100%" height="100%" viewBox="0 0 ${this.width} ${this.height}" preserveAspectRatio="xMidYMid meet"></svg>
        </div>`;
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has("stats")) {
            this.drawGraph();
        }
    }

    drawGraph() {
        const svg = this.shadowRoot?.getElementById('stats') as SVGSVGElement | null;
        if (!svg || !this.stats) return;

        svg.innerHTML = ''; // Clear previous graph

        const data: DonutData[] = [
            { label: "promo", value: this.stats?.promo_count_non_zero },
            { label: "25%", value: this.stats?.promo_count_25 },
            { label: "50%", value: this.stats?.promo_count_50 },
            { label: "overig", value: this.stats?.product_count - this.stats?.promo_count_non_zero - this.stats?.promo_count_25 - this.stats?.promo_count_50 }
        ];

        const radius = Math.min(this.width, this.height) / 2 - 50;

        const color = d3.scaleOrdinal<string>()
            .domain(data.map(d => d.label))
            .range(["blue", "orange", "red", "lightgrey"]);

        const pie = d3.pie<DonutData>()
            .sort(null)
            .value(d => d.value);

        const arc = d3.arc<PieArcDatum<DonutData>>()
            .innerRadius(radius - 100)
            .outerRadius(radius);

        const svg_g = d3.select(svg)
            .append("g")
            .attr("transform", `translate(${this.width / 2}, ${this.height / 2})`);

        const arcs = svg_g.selectAll("arc")
            .data(pie(data))
            .enter()
            .append("g")
            .attr("class", "arc");

        arcs.append("path")
            .attr("d", arc)
            .attr("fill", d => color(d.data.label));

        arcs.append("text")
            .attr("transform", d => `translate(${arc.centroid(d)})`)
            .attr("text-anchor", "middle")
            .text(d => d.data.label)
            .style("fill", "#fff");

        // svg_g.append("rect")
        //   .attr("width", this.width/2)
        //   .attr("height", 10)
        //   .attr("dy", ".35em")
        svg_g.append("rect")
            .attr("x", -120)
            .attr("y", -50)
            .attr("rx", 15)  // This sets the horizontal radius of the rounded corners
            .attr("ry", 15)  // This sets the vertical radius of the rounded corners
            .attr("width", 240)
            .attr("height", 120)
            .attr("class", "title-background");

        svg_g.append("text")
            .attr("text-anchor", "middle")
            .attr("dy", ".35em")
            .attr("class", "product-count")
            .text(`${this.stats.product_count}`);
    }
}
